export const CONSENT_GET_CONSENTS = "CONSENT_GET_CONSENTS";
export const CONSENT_CREATE_FAILURE = "CONSENT_CREATE_FAILURE";
